import "./styles/fixed-navigation.css";
import "./styles/contained-controls.css";
import "../../shared/academy-brand.css";
import React from "react";
import App from "./App";
import { mountFrontend } from "./app/bootstrap";
import { APP_ID } from "./config/environment";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

const root = document.getElementById("root");
if (!root) throw new Error("Unable to find the Proctor Studio root element.");

void mountFrontend(
  root,
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
  APP_ID,
);
